import type { ThemeConfig } from "antd";
import { theme } from "antd";

import { darkTheme, lightTheme } from "./theme";

export const antdCommonConfig: ThemeConfig["components"] = {
    Typography: {
        fontFamily: "Inter",
    },
    Button: {
        colorPrimary: "#3A57E8",
        colorSuccessBg: "#52C41A",
        borderRadius: 50,
        fontSize: 16,
    },
    Card: {
        actionsBg: "#212121",
    },
    Select: {
        fontSize: 20,
        lineHeight: 1.3,
        zIndexPopup: 9999,
        optionActiveBg: "transparent",
    },
    Segmented: {
        trackBg: "#1F1F1F",
        itemSelectedBg: "#000000",
        trackPadding: "5px",
    },
    Collapse: {
        headerPadding: "16px",
        fontSize: 16,
    },
    Carousel: {
        arrowSize: 20,
    },
};

export const antdLightTheme: ThemeConfig = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorError: lightTheme.dangerTypographyColor,
        colorErrorText: lightTheme.dangerTypographyColor,
        colorText: lightTheme.primaryTypographyColor,
    },
    components: {
        ...antdCommonConfig,
        Typography: {
            ...antdCommonConfig.Typography,
            colorPrimary: lightTheme.primaryTypographyColor,
        },
        Collapse: {
            ...antdCommonConfig.Collapse,
            contentBg: "#e7e7e7",
            headerBg: "#e7e7e7",
        },
        Layout: {
            headerBg: "#e7e7e7",
            headerColor: "#ffffff",
            footerBg: "#e7e7e7",
        },
    },
};

export const antdDarkTheme: ThemeConfig = {
    algorithm: theme.darkAlgorithm,
    token: {
        colorError: darkTheme.dangerTypographyColor,
        colorErrorText: darkTheme.dangerTypographyColor,
        colorText: darkTheme.primaryTypographyColor,
    },
    components: {
        ...antdCommonConfig,
        Typography: {
            ...antdCommonConfig.Typography,
            colorPrimary: darkTheme.primaryTypographyColor,
        },
        Collapse: {
            ...antdCommonConfig.Collapse,
            contentBg: "#141414",
            headerBg: "#141414",
        },
        Layout: {
            headerBg: "#181818",
            headerColor: "#000000",
            footerBg: "#181818",
        },
    },
};
